import { AnalyticsTagType } from '@/types/api'

import { applyDefaultFacetValues } from './apply-default-facet-values'
import { isBrandCategoryMetas, isBrandMetas, isCategoryMetas, isCombinationMetas, isTagMetas } from './type-guards'

import { PLPBasicMetasProps, PLPPages, PlpSearchParams } from '../types'

interface PopulateSearchParamsFromBasicMetasProps {
    page: PLPPages
    basicMetas?: PLPBasicMetasProps
    searchParams?: PlpSearchParams
}

export function populateSearchParamsFromBasicMetas({
    page,
    basicMetas = {},
    searchParams = {},
}: PopulateSearchParamsFromBasicMetasProps): PlpSearchParams {
    const populatedSearchParams = { ...searchParams }

    if (page === PLPPages.Search) {
        populatedSearchParams.analytics_tag = AnalyticsTagType.SearchPLP
        return populatedSearchParams
    }

    switch (page) {
        case PLPPages.Categories: {
            if (isCategoryMetas(page, basicMetas)) {
                populatedSearchParams.cat_id = basicMetas.id
                populatedSearchParams.analytics_tag = AnalyticsTagType.CategoryPLP
            }
            break
        }

        case PLPPages.Brands: {
            if (isBrandMetas(page, basicMetas)) {
                populatedSearchParams.brand_id = basicMetas.id
                populatedSearchParams.analytics_tag = AnalyticsTagType.BrandPLP
            }
            break
        }

        case PLPPages.Tags: {
            if (isTagMetas(page, basicMetas)) {
                populatedSearchParams.tag_id = String(basicMetas.id)
                populatedSearchParams.analytics_tag = AnalyticsTagType.TagPLP
            }
            break
        }

        case PLPPages.Combination: {
            if (isBrandCategoryMetas(page, basicMetas)) {
                populatedSearchParams.brand_id = basicMetas.brand.id
                populatedSearchParams.cat_id = basicMetas.category.id
                populatedSearchParams.analytics_tag = AnalyticsTagType.BrandCategoryPLP
            }
            break
        }

        case PLPPages.Facets: {
            if (isCombinationMetas(page, basicMetas)) {
                const { categoryId, facet: facetItems } = basicMetas

                if (categoryId) populatedSearchParams.cat_id = String(categoryId)

                populatedSearchParams.analytics_tag = AnalyticsTagType.CategoryPLP

                if (facetItems?.length) {
                    Object.assign(
                        populatedSearchParams,
                        applyDefaultFacetValues({ searchParams: populatedSearchParams, facetItems })
                    )
                }
            }
            break
        }

        case PLPPages.BrandCategoriesCombination: {
            if (isCombinationMetas(page, basicMetas)) {
                populatedSearchParams.cat_id = String(basicMetas.categoryId)
                populatedSearchParams.brand_id = String(basicMetas?.brand?.id)
                populatedSearchParams.analytics_tag = AnalyticsTagType.BrandCategoryPLP
            }
            break
        }
    }

    return populatedSearchParams
}
